import { render, staticRenderFns } from "./notes-form.vue?vue&type=template&id=16021054&scoped=true"
import script from "./notes-form.vue?vue&type=script&lang=js"
export * from "./notes-form.vue?vue&type=script&lang=js"
import style0 from "./notes-form.vue?vue&type=style&index=0&id=16021054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16021054",
  null
  
)

export default component.exports